import { call, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalEventDispatcher,
  GlobalPut,
  ModalType,
  SpeichernStatus,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { DashboardActions } from '../dashboard.actions';
import { IAppState } from '../appState';
import { refuseWhileShopPricingIsStale } from './helper-functions/shopPricingStaleGuard';

export function* requestForwardToAgentSaga() {
  yield takeEvery(
    DashboardActions.REQUEST_FORWARD_TO_AGENT,
    safeSaga(handleForwardToAgent, App.SHOP_DASHBOARD),
  );
}

export function* handleForwardToAgent() {
  const globalActions = new GlobalActions();
  const dashboardActions = new DashboardActions();

  const state: IAppState = yield select();
  if (yield* refuseWhileShopPricingIsStale(state)) {
    return;
  }

  try {
    GlobalEventDispatcher.getInstance().dispatch(dashboardActions.forwardToAgentStarted());

    yield call(GlobalPut.getInstance().put, globalActions.speichernRequested(false));
    const saveStatus: GlobalAction<SpeichernStatus> = yield take(
      GlobalActions.SAVE_STATUS_RECEIVED,
    );

    if (saveStatus.payload.status !== 200) {
      yield call(
        GlobalPut.getInstance().put,
        globalActions.requestModal(ModalType.FORWARD_TO_AGENT_ERROR, {
          body: 'Beim Zurückgeben an den Vertreter ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
          button: 'Schließen',
        }),
      );
      return;
    }

    yield call(GlobalPut.getInstance().put, globalActions.setShowTransferToAgentPage(true));
  } finally {
    GlobalEventDispatcher.getInstance().dispatch(dashboardActions.forwardToAgentFinished());
  }
}
